import educationFilter from './filter';

export default (options) => {
    items.create($.extend({
        name: 'education',
        scroll_window: location.href.indexOf('education') > -1,
        first_load: location.href.indexOf('education') > -1,
        data: educationFilter,
        html: function (html, data) {
            if (data.image) {
                html.css({
                    'background-image': 'url(' + data.image + ')'
                });
            }

            return html;
        }
    }, options));
}